<template>
  <v-container>
    <v-row>
      <v-col class="xs-12" cols="12">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{$t('Project.Settings.Locations.Data.Title')}}</v-toolbar-title>
          </v-toolbar>
          <v-row>
            <v-col xs5 cols="5">
              <ProjectDataList />
            </v-col>
            <v-col xs7 cols="7">
              <ProjectLocationDetails v-if="getSelectedProjectDataIndex === 0" :address="getProjectAddress($route.params.project_id)" :project_id="$route.params.project_id" />
              <ProjectLocationDetails v-if="getSelectedProjectDataIndex === 1" :address="getProjectInvoiceAddress($route.params.project_id)" :project_id="$route.params.project_id" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import store from '@/store/index'
import { mapGetters } from 'vuex';
import ProjectDataList from '@/components/ProjectSettings/ProjectDataList.component.vue'
import ProjectLocationDetails from '@/components/ProjectSettings/ProjectLocationDetails.component.vue'
export default {
  components: {
    ProjectDataList,
    ProjectLocationDetails
  },
  name: 'ProjectData',
  beforeRouteEnter (to, from, next) {
    store.dispatch('Project/requestProjectAddress', {
      project_id: to.params.project_id
    }).then(res => {
      next(res);
    });
  },
  computed: {
    ...mapGetters('Project', [
      'getProjectLocation',
      'getProjectAddress',
      'getProjectInvoiceAddress'
    ]),
    ...mapGetters('View', [
      'getSelectedProjectDataIndex'
    ]),
    project_id() {
      return parseInt(this.$route.params.project_id);
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
